
import { applicantStore } from '@/store'
import { ValidationObserver } from 'vee-validate'
import { ValidationError, ApplicationContactAddress } from '@/commons/types'
import { Component } from 'vue-property-decorator'
import { FALLBACK_LOCALE } from '@/commons/constants/locale'
import { ProviderInstance } from 'vee-validate/dist/types/types'
import InputWithLabel from '@/commons/components/core/InputWithLabel.vue'
import TextareaWithLabel from '@/commons/components/core/TextareaWithLabel.vue'
import { translateValidationError } from '@/commons/configuration/vee.validate'
import AdsSearch from '@/commons/components/application-create/person-contacts/AdsSearch.vue'

import {
    validatorIds,
    ContactValidationFieldName
} from '@/commons/constants/application'
import { ENVIRONMENT } from '@/commons/configuration'

@Component({
    components: {
        AdsSearch,
        InputWithLabel,
        TextareaWithLabel
    }
})
export default class PersonContactsEstonianAddress extends ValidationObserver {
    inAds = false
    domValidatorIds = validatorIds
    adsValidatorId = ContactValidationFieldName.ADDRESS_ADS_ADR_ID
    postalCodeValidationId = ContactValidationFieldName.ADDRESS_POSTAL_CODE
    addressNotesValidationId = ContactValidationFieldName.ADDRESS_NOTES

    get fullAddress (): string {
        return this.address.fullAddress || ''
    }

    get address (): ApplicationContactAddress {
        return applicantStore.applicationContact.address
    }

    get postalCodeLink (): string {
        return ENVIRONMENT.postalCodeUrl[this.$i18n.locale || FALLBACK_LOCALE]
    }

    get adsLink (): string {
        return ENVIRONMENT.adsUrl[this.$i18n.locale || FALLBACK_LOCALE]
    }

    setPostalCode (value: string): void {
        this.address.postalCode = value
    }

    handleAdsBlur (): void {
        (this.$refs.adsValidator as ProviderInstance).validate()
    }

    translateError (validationError: ValidationError): string {
        return translateValidationError(validationError)
    }

    setAddressNotes (notes: string): void {
        this.address.notes = notes
    }
}
